export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
    >
      <path
        d="M0.549805 3.92857C0.549805 2.0375 2.02965 0.5 3.8498 0.5H23.6498C25.47 0.5 26.9498 2.0375 26.9498 3.92857V21.0714C26.9498 22.9625 25.47 24.5 23.6498 24.5H3.8498C2.02965 24.5 0.549805 22.9625 0.549805 21.0714V3.92857ZM17.2457 9.63393C17.0137 9.28036 16.6321 9.07143 16.2248 9.07143C15.8175 9.07143 15.4307 9.28036 15.2039 9.63393L10.7179 16.4696L9.35152 14.6964C9.11434 14.3911 8.75856 14.2143 8.38731 14.2143C8.01606 14.2143 7.65512 14.3911 7.42309 14.6964L4.12309 18.9821C3.82402 19.3679 3.7673 19.8982 3.97355 20.3429C4.17981 20.7875 4.61293 21.0714 5.08731 21.0714H22.4123C22.8712 21.0714 23.294 20.8089 23.5054 20.3857C23.7168 19.9625 23.6911 19.4536 23.4332 19.0625L17.2457 9.63393ZM6.32481 9.07143C6.98122 9.07143 7.61074 8.80051 8.07489 8.31827C8.53905 7.83604 8.7998 7.18199 8.7998 6.5C8.7998 5.81801 8.53905 5.16396 8.07489 4.68173C7.61074 4.19949 6.98122 3.92857 6.32481 3.92857C5.66839 3.92857 5.03887 4.19949 4.57472 4.68173C4.11056 5.16396 3.8498 5.81801 3.8498 6.5C3.8498 7.18199 4.11056 7.83604 4.57472 8.31827C5.03887 8.80051 5.66839 9.07143 6.32481 9.07143Z"
        fill="#6C7278"
      />
    </svg>
  );
};
